/**
 * FTUE / Tutorial step definitions. Each step has a message shown in the
 * TutorialOverlay AND an event that auto-advances the player past it.
 *
 * Player progress is stored as `player.tutorialStep: number`:
 *   - 0 = fresh / hasn't entered a vault yet
 *   - 1 = entered first vault, watching auto-combat
 *   - 2 = first kill done
 *   - 3 = first equipment drop (loot from a run)
 *   - 4 = first upgrade applied
 *   - 5 = first vault tier cleared (boss + endless unlocked)
 *   - 99 = tutorial completed or skipped
 *
 * The overlay shows the message for the CURRENT step. Player advances by
 * doing the suggested action (event-driven) or via the Skip button.
 */

export const TUTORIAL_DONE = 99;

export interface TutorialStepDef {
  step: number;
  title: string;
  body: string;
  /** Which UI region the player should look at. The overlay positions
   *  itself with a relative arrow. */
  pointAt: 'bottom-nav-dungeon' | 'combat-hud' | 'floor-drops' | 'victory-claim' | 'hero-tab' | 'bosses-tab';
}

export const TUTORIAL_STEPS: TutorialStepDef[] = [
  {
    step: 0,
    title: 'Willkommen, Runner',
    body: 'Tippe unten auf den ⚔ Dungeon-Tab, um deinen ersten Vault zu betreten.',
    pointAt: 'bottom-nav-dungeon',
  },
  {
    step: 1,
    title: 'Auto-Combat',
    body: 'Im Vault greift dein Runner automatisch an. Bleibe stehen, um zu kämpfen — bewege dich, um zu pausieren.',
    pointAt: 'combat-hud',
  },
  {
    step: 2,
    title: 'Erster Kill',
    body: 'Beute fällt zu Boden — du sammelst sie ein, wenn du darüberläufst.',
    pointAt: 'floor-drops',
  },
  {
    step: 3,
    title: 'Beute sichern',
    body: 'Run beendet. Tippe auf „Loot abholen", um Ausrüstung ins Inventar zu legen.',
    pointAt: 'victory-claim',
  },
  {
    step: 4,
    title: 'Equipment aufwerten',
    body: 'Im 👤 Hero-Tab kannst du Items aufwerten. Wähle einen Slot, tippe ein Item zum Upgrade.',
    pointAt: 'hero-tab',
  },
  {
    step: 5,
    title: 'Vault Tier 1 geschafft',
    body: 'Weltbosse + Endless Fight sind jetzt freigeschaltet. Versuche es im ☠ Bosse-Tab.',
    pointAt: 'bosses-tab',
  },
];

export function getTutorialStep(step: number): TutorialStepDef | null {
  return TUTORIAL_STEPS.find((s) => s.step === step) ?? null;
}
